export const ap11PtBr = {
  title: 'Notas fiscais recebidas conciliadas com contas a pagar',
  description:
    'Confere se cada NF recebida pelo Focus no período foi vinculada ou corresponde exatamente a uma conta a pagar e se cancelamentos posteriores foram refletidos na obrigação.',
  prerequisite: '',
  detail: {
    analyzedLabel: 'Notas analisadas',
    linkedLabel: 'Notas conciliadas',
    unlinkedLabel: 'Notas pendentes',
    cancelledLabel: 'Notas canceladas',
    analyzed: '{{count}} notas analisadas',
    linked: '{{count}} vinculadas ou com match exato',
    unlinked: '{{count}} sem conta correspondente',
    cancelled: '{{count}} canceladas até o corte',
    historicalUnknown:
      'O estado histórico de {{count}} notas não pôde ser comprovado porque o evento antigo não tem data.',
    feedStale:
      'O Focus ainda não confirmou uma sincronização completa até a data de corte. O resultado não pode liberar o fechamento.',
    feedStaleWithDetails:
      'Cobertura parcial do Focus: status {{status}}, última sincronização {{lastSync}}, corte {{cutoff}}.',
    notConfigured: 'não configurado',
    neverSynced: 'nunca sincronizado',
    historicalReasons: {
      CANCELLATION_DATE_MISSING: 'Cancelamento sem data histórica',
      LINK_STATE_AFTER_CUTOFF_UNKNOWN: 'Estado do vínculo no corte não comprovado',
      BILL_STATUS_AT_CUTOFF_UNKNOWN: 'Status da conta no corte não comprovado',
    },
    truncated: 'Mostrando {{shown}} de {{count}} pendências.',
    openReceivedNfs: 'Abrir notas recebidas',
    openBill: 'Abrir conta',
  },
  reasons: {
    RECEIVED_FISCAL_DOCUMENT_UNMATCHED: {
      title: 'Notas sem conta a pagar correspondente',
      item: 'nota recebida sem vínculo ou match exato',
    },
    CANCELLED_FISCAL_DOCUMENT_WITH_PAID_BILL: {
      title: 'Notas canceladas com conta já paga',
      item: 'nota cancelada cuja conta consta como paga no corte',
    },
    CANCELLED_FISCAL_DOCUMENT_WITH_LIVE_BILL: {
      title: 'Notas canceladas com obrigação ativa',
      item: 'nota cancelada ainda vinculada a uma obrigação ativa',
    },
    ACTIVE_FISCAL_DOCUMENT_WITH_INVALID_BILL: {
      title: 'Notas ativas vinculadas a contas inválidas',
      item: 'nota ativa cuja conta foi rejeitada, anulada ou excluída',
    },
    other: { title: 'Outras divergências', item: 'divergência entre a nota e a conta' },
  },
};

export const ap11En: typeof ap11PtBr = {
  title: 'Received fiscal documents reconciled to accounts payable',
  description:
    'Checks whether every fiscal document received through Focus in the period was linked or exactly matched to a bill and whether later cancellations were reflected in the obligation.',
  prerequisite: '',
  detail: {
    analyzedLabel: 'Documents analyzed',
    linkedLabel: 'Documents reconciled',
    unlinkedLabel: 'Documents pending',
    cancelledLabel: 'Documents cancelled',
    analyzed: '{{count}} documents analyzed',
    linked: '{{count}} linked or exactly matched',
    unlinked: '{{count}} without a matching bill',
    cancelled: '{{count}} cancelled by the cutoff',
    historicalUnknown:
      'The historical state of {{count}} documents could not be proven because the old event has no date.',
    feedStale:
      'Focus has not confirmed a complete sync through the cutoff date. This result cannot clear the close.',
    feedStaleWithDetails:
      'Partial Focus coverage: status {{status}}, last sync {{lastSync}}, cutoff {{cutoff}}.',
    notConfigured: 'not configured',
    neverSynced: 'never synced',
    historicalReasons: {
      CANCELLATION_DATE_MISSING: 'Cancellation has no historical date',
      LINK_STATE_AFTER_CUTOFF_UNKNOWN: 'Link state at cutoff is unproven',
      BILL_STATUS_AT_CUTOFF_UNKNOWN: 'Bill status at cutoff is unproven',
    },
    truncated: 'Showing {{shown}} of {{count}} open items.',
    openReceivedNfs: 'Open received documents',
    openBill: 'Open bill',
  },
  reasons: {
    RECEIVED_FISCAL_DOCUMENT_UNMATCHED: {
      title: 'Documents without a matching bill',
      item: 'received document without a link or exact match',
    },
    CANCELLED_FISCAL_DOCUMENT_WITH_PAID_BILL: {
      title: 'Cancelled documents with a paid bill',
      item: 'cancelled document whose bill is paid at the cutoff',
    },
    CANCELLED_FISCAL_DOCUMENT_WITH_LIVE_BILL: {
      title: 'Cancelled documents with a live obligation',
      item: 'cancelled document still linked to a live obligation',
    },
    ACTIVE_FISCAL_DOCUMENT_WITH_INVALID_BILL: {
      title: 'Active documents linked to invalid bills',
      item: 'active document whose bill was rejected, voided or deleted',
    },
    other: { title: 'Other mismatches', item: 'fiscal document and bill mismatch' },
  },
};
